module.exports = __webpack_public_path__ + "static/summon_celestial-b1f18be6b662645cae2d07adc4411252.png";